function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 1400 980",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1400px",
    height: "980px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.7013887166976929, 0, 0, 1.7013887166976929, 1185.6226901022692, 0.0000021118132735864492)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F43F5E"
    },
    d: "M135.91,129.458l39.499-53.117l-51.055-37.966c0,0-22.406-12.864-62.402,40.839l-0.001-0.001 c-0.028,0.038-0.054,0.074-0.082,0.112c-0.011,0.014-0.021,0.027-0.031,0.041l0,0C21.92,133.129,40.69,150.883,40.69,150.883 l51.056,37.967L135.91,129.458L135.91,129.458z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132.141006 84.914001 H 196.212006 V 225.119003 H 132.141006 V 84.914001 Z",
    transform: "matrix(0.8024 0.5967 -0.5967 0.8024 124.9361 -67.3443)",
    style: {
      fill: "#C7C8CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 236.66400146484375 121.55799865722656 L 152.83900451660156 234.281005859375 L 392.48199462890625 412.4859924316406 L 385.72698974609375 368.55999755859375 L 432.197998046875 358.17999267578125 L 427.2590026855469 310.9110107421875 L 473.8399963378906 301.2829895019531 Z",
    style: {
      fill: "#FBBF24"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 475.6610107421875 305.7980041503906 L 432.5090026855469 314.63299560546875 L 437.7439880371094 362.4020080566406 L 391.9280090332031 373.0989990234375 L 397.8550109863281 415.1449890136719 L 478.1130065917969 426.7200012207031 L 510.5369873046875 384.0159912109375 Z",
    style: {
      fill: "#FEF08A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 482.8399963378906 428.8970031738281 L 513.3930053710938 387.8110046386719 L 537.14599609375 437.2170104980469 Z",
    style: {
      fill: "#231F20"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f0c451f70cd0453849af7ac527eb5b2d.svg";
export { ForwardRef as ReactComponent };